import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app from '@devices/settings/device_settings/app.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_bt_home_control_gen_2 from '../device_settings/bluetooth_bt_home_control_gen_2';
import scripts_gen_2 from '../device_settings/scripts_gen_2';

export default [
	schedule_gen_2,
	webhooks_gen_2,
	scripts_gen_2,
	networks_gen_2_plus,
	bluetooth_bt_home_control_gen_2,
	app,
	share,
	{
		title: 'settings',
		components: [
			{ title: 'device_name', component: 'device_name_sys' },
			{ title: 'reverse_directions', component: 'reverse_direction_g2' },
			{ title: 'action_on_power_on', component: 'action_on_power_on_g2_cover' },
			//todo need maintance mode settings
			{ title: 'firmware_version', component: 'firmware_update' },
			{ title: 'geo_location_and_time_zone', component: 'location_g2' },
			{ title: 'device_reboot', component: 'device_reboot' },
			{ title: 'factory_reset', component: 'factory_reset' },
			{ title: 'device_information', component: 'device_information' },
		],
	},
];
